export default __webpack_public_path__ + "static/media/striation.ac8bbd8d.png";